export const COURT_COLLECTION = 'courts';